import { useContext, RefObject } from 'react';
import createNamedContext from 'utils/createNamedContext';

export type ContextValue = RefObject<HTMLElement>;

function createRefContext(name: string) {
  const RefContext = createNamedContext<ContextValue>(name, { current: null });

  const useRefContext = () => {
    return useContext(RefContext);
  };

  return {
    RefContext,
    useRefContext,
  };
}

const { RefContext: SiderRefContext, useRefContext: useSiderRefContext } =
  createRefContext('SiderRefContext');

export { SiderRefContext, useSiderRefContext };

export default createRefContext;
